import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const PARAMETER_PATH = 'parameter'

//#region Page
export function getPageParameters(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PARAMETER_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region List
export function getListParameters(userId, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PARAMETER_PATH}/getList`, filterRequest, {
            params: {
                userId,
                dto,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdateParameter(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${PARAMETER_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Detail
export function getParameterByUser(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${PARAMETER_PATH}/getByUserId`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion
